import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private messageService: MessageService) {}

  showSuccess(summary: string, detail?: string, life: number = 2000): void {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life
    });
  }

  showError(summary: string, detail?: string, life: number = 7000): void {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life
    });
  }

  showWarning(summary: string, detail?: string, life: number = 5000): void {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      life
    });
  }

  showInfo(summary: string, detail?: string, life: number = 5000): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      life
    });
  }

  clear(): void {
    this.messageService.clear();
  }
}
